import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Box from '@mui/material/Box';

type HeaderCellProps = {
  id: string;
  label: string;
  pad?: boolean;
};

export type TableHeaderProps = {
  orderBy: string;
  sortOrder?: 'asc' | 'desc';
  onRequestSort: (field: string) => void;
};

const Header = ({
  orderBy,
  sortOrder = 'asc',
  onRequestSort,
}: TableHeaderProps) => {
  const HeaderCell = ({ id, label }: HeaderCellProps) => (
    <TableCell
      key={id}
      align="left"
      size="small"
      padding="normal"
      sortDirection={id === orderBy ? sortOrder : false}
    >
      <TableSortLabel
        active={id === orderBy}
        direction={sortOrder}
        onClick={() => onRequestSort(id)}
      >
        {label}
        {id === orderBy ? (
          <Box
            component="span"
            sx={{
              border: 0,
              clip: 'rect(0,0,0,0)',
              height: 1,
              margin: -1,
              overflow: 'hidden',
              padding: 0,
              position: 'absolute',
              top: 20,
              width: 1,
            }}
          >
            {sortOrder === 'desc' ? 'sorted descending' : 'sorted ascending'}
          </Box>
        ) : null}
      </TableSortLabel>
    </TableCell>
  );

  return (
    <TableHead>
      <TableRow>
        <HeaderCell id="date" label="Date" />
        <HeaderCell id="uid" label="Unique ID" />
        <HeaderCell id="sendAmount" label="Send" />
        <HeaderCell id="receiveAmount" label="Receive" />
        <HeaderCell id="senderName" label="Sender" />
        <HeaderCell id="recipientName" label="Recipient" />
        <HeaderCell id="exchangeRate" label="Xch Rate" />
        <HeaderCell id="agentEmail" label="Agent Email" />
        <HeaderCell id="status" label="Status" />
        <TableCell padding="normal"></TableCell>
      </TableRow>
    </TableHead>
  );
};

export default Header;
